import { Any, JsonObject, JsonProperty } from 'json2typescript';
import { NewsTranslation } from './news-translation.model';
import { NewsReward } from './news-reward.model';
import { NewsPeriodicity } from './news-periodicity.model';

@JsonObject('News')
export class News {

  @JsonProperty('news_id', Number)
  newsId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('start_timestamp', Number)
  startTimestamp: number = 0;

  @JsonProperty('end_timestamp', Number)
  endTimestamp: number = 0;

  @JsonProperty('is_active', Boolean)
  isActive: boolean = false;

  @JsonProperty('is_rate', Boolean)
  isRate: boolean = false;

  @JsonProperty('user_created_after_timestamp', Any)
  userCreatedAfterTimestamp: number | null = null;

  @JsonProperty('user_created_before_timestamp', Any)
  userCreatedBeforeTimestamp: number | null = null;

  @JsonProperty('news_predefined_id', Any)
  newsPredefinedId: number | null = null;

  @JsonProperty('link_default', String)
  linkDefault: string = '';

  @JsonProperty('link_ios', String)
  linkIos: string = '';

  @JsonProperty('link_android', String)
  linkAndroid: string = '';

  @JsonProperty('translations', [NewsTranslation])
  translations: NewsTranslation[] = [];

  @JsonProperty('rewards', [NewsReward])
  rewards: NewsReward[] = [];

  @JsonProperty('periodicity', Any)
  periodicity: NewsPeriodicity | null = null;
}
